import { createContext, useContext } from 'react';

const ToneContext = createContext('light');

/**
 * Sets the tone ('light' | 'dark') that the marketing primitives inside it
 * default to. `Section` provides one from its own surface, so a heading or a
 * button on a dark section is dark without being told. Wrap a light card that
 * sits on a dark section (or the reverse) in `<Tone>` to switch its contents.
 */
export default function Tone({ tone, children }) {
    return <ToneContext.Provider value={tone}>{children}</ToneContext.Provider>;
}

/**
 * The tone a primitive should render in: its own `tone` prop when it was
 * given one, otherwise the surrounding `<Tone>`. Anything but 'dark' is light.
 */
export function useTone(tone) {
    const inherited = useContext(ToneContext);

    return (tone ?? inherited) === 'dark' ? 'dark' : 'light';
}
